module.exports = __webpack_public_path__ + "static/media/form-mobile.6c39d5c8.webp";